<template>
  <loader v-if="!loaded" :size="24" />

  <img
    v-else
    :src="content"
    :alt="alt"
    @load="loaded = true"
    @click="$emit('click')"
    ref="baseImage"
    v-bind="$attrs" />


</template>

<script>
import { getFileByUrl } from "Adapters/ApiAdapter/file";
import { STATIC_IMG_PATH } from "Consts/static";
import Loader from "Components/Loader";

export default {
  name: "BaseImage",
  components: { Loader },
  props: {
    src: {
      type: String,
      default: "",
    },
    alt: {
      type: String,
      default: "",
    },
  },
  watch: {
    src() {
      this.getImage();
    },
  },
  computed: {
    isDomainSpecific() {
      return this.src?.includes(window.location.hostname);
    },
    isDomainPublicFile() {
      return this.src?.includes(STATIC_IMG_PATH);
    },
  },
  data() {
    return {
      content: `${STATIC_IMG_PATH}/imagePlaceholder.svg`,
      loaded: false,
    };
  },
  methods: {
    init() {
      this.getImage();
      this.loaded = true;
      this.$emit("load");
    },
    isInvalidBlobSvg(blob) {
      return this.src.includes(".svg") && blob.type === "raw/svg";
    },
    async getImage() {
      if (this.isDomainSpecific && !this.isDomainPublicFile) {
        const { data } = await getFileByUrl(this.src);
        const blobData = this.isInvalidBlobSvg(data)
          ? new Blob([data], { type: "image/svg+xml;charset=utf-8" })
          : data;
        return this.loadImage(blobData);
      }
      if (this.src) {
        this.content = this.src;
      }
    },
    loadImage(data) {
      if (!this.src) return;
      const reader = new FileReader();
      reader.readAsDataURL(data);
      reader.onload = (e) => {
        this.content = e.target.result;
      };
    },
  },
  created() {
    this.init();
  },
};
</script>

<style scoped></style>
